export default __webpack_public_path__ + "static/media/truck-registration.95908b3a.svg";